import { useEffect, useState } from "react";
import { fetchProducts, ShopifyProduct } from "@/lib/shopify";
import { ProductCard } from "./ProductCard";
import { Loader2 } from "lucide-react";
import { logger } from "@/lib/logger";
import { toast } from "sonner";

export const ProductGrid = () => {
  const [products, setProducts] = useState<ShopifyProduct[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const loadProducts = async () => {
      try {
        const data = await fetchProducts(20);
        setProducts(data);
      } catch (error) {
        logger.error('Error loading products:', error);
        toast.error('Failed to load products', {
          description: 'Please refresh the page to try again'
        });
      } finally {
        setLoading(false);
      }
    };

    loadProducts();
  }, []);

  if (loading) {
    return (
      <div className="flex items-center justify-center py-20">
        <Loader2 className="h-8 w-8 animate-spin text-primary" />
      </div>
    );
  }

  if (products.length === 0) {
    return (
      <div className="text-center py-20">
        <h3 className="text-2xl font-semibold mb-2">No products found</h3>
        <p className="text-muted-foreground">
          Start adding products by telling me what you'd like to sell and the price!
        </p>
      </div>
    );
  }

  // Lead with the Stage 1 / Stage 2 advisory programmes, then advisory, book, courses
  const order = [
    'stage-1-investor-readiness-monthly-advisory',
    'stage-2-investor-engagement',
    'embedded-advisor',
    'the-founder-laws',
  ];

  const sortedProducts = [...products].sort((a, b) => {
    const ia = order.indexOf(a.node.handle);
    const ib = order.indexOf(b.node.handle);
    return (ia === -1 ? order.length : ia) - (ib === -1 ? order.length : ib);
  });


  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6">
      {sortedProducts.map((product) => (
        <ProductCard key={product.node.id} product={product} />
      ))}
    </div>
  );
};
